package org.zq.astrock_ai.api

object StockCodes {
    val defaultWatchlist = listOf(
        "002141", "600519", "300750", "002594", "688981", "000858", "601012", "600036",
    )

    val indexSecIds = listOf(
        "1.000001" to "上证指数",
        "0.399001" to "深证成指",
        "0.399006" to "创业板指",
        "1.000688" to "科创50",
        "1.000300" to "沪深300",
    )

    fun toSecId(code: String): String = when {
        code.startsWith("6") || code.startsWith("5") -> "1.$code"
        else -> "0.$code"
    }

    fun toFullCode(code: String): String = when {
        code.startsWith("6") || code.startsWith("5") -> "$code.SH"
        else -> "$code.SZ"
    }

    fun toSinaCode(code: String): String = when {
        code.startsWith("6") || code.startsWith("5") -> "sh$code"
        else -> "sz$code"
    }

    /** 腾讯行情代码，如 sh600519 / sz300750 */
    fun toTencentCode(code: String): String = toSinaCode(code)
}
